import { useSelector } from "react-redux"

export const useAgenceId = () => {
    const currentAgence = useSelector(state => state.agences?.currentAgence)
    // console.log({ currentAgence });
    return { agenceId: currentAgence?.id } 
}